
import styled from 'styled-components';
const TopNavBG = styled.div`
    background-image: url("https://i.pinimg.com/originals/63/ca/e3/63cae32755b96679623a4a88971399ea.jpg");
    background-position: 0px -150px;
    background-size: auto cover; 
`;
  
  export default TopNavBG;